module.exports = __webpack_public_path__ + "static/img/11.6623575.png";


//////////////////
// WEBPACK FOOTER
// ./static/goumai/11.png
// module id = ZdKx
// module chunks = 14